import * as a11ydrops from 'a11ydrops';

// Main Nav Drops
let mainNav = document.querySelector('#main-nav .menu');
if (mainNav) {
	a11ydrops.init(mainNav, {
		// options
		selector: 'li',
		menu: '.sub-menu',
		hover: true,
		hover_width: 1024,
		buttonText: '<span class="sr-only">Toggle Menu</span>',
	});
}

// Search Drop
let searchDrop = document.querySelector('.search-drop');
if (searchDrop) {
	a11ydrops.init(searchDrop, {
		// options
		selector: '.search-drop--inner',
		menu: '.searchform',
		hover: false,
		buttonClasses: 'styled-action search-toggle',
		buttonText: '<span class="sr-only">Toggle Search</span>',
	});
}

// Close SearchDrop if main menu hovered
let menuItems = document.querySelectorAll('.main-nav > ul > li'); // get top level items
if (menuItems) {
	menuItems.forEach(function (item) {
		item.addEventListener('mouseover', searchDropRemove);
	});
}

function searchDropRemove() {
	let searchToggle = searchDrop.querySelector('button.search-toggle');
	if (searchToggle && searchToggle.classList.contains('active')) {
		searchToggle.click();
		searchToggle.blur();
	}
}

let hoverMenuItems = document.querySelectorAll('li.menu-item-has-children');
let toggleButtons = document.querySelectorAll('.a11ydrops-btn');
const isTouchScreen = window.matchMedia('(hover: none)').matches;

hoverMenuItems.forEach(function (menuItem) {
	if (!isTouchScreen) {
		menuItem.addEventListener('mouseenter', function (e) {
			e.currentTarget.classList.add('active');
		});
		menuItem.addEventListener('mouseleave', function (e) {
			e.currentTarget.classList.remove('active');
		});
	}
});

toggleButtons.forEach(function (btn) {
	btn.addEventListener('click', function () {
		let parentMenuItem = btn.closest('.menu-item-has-children');

		if (parentMenuItem) {
			parentMenuItem.classList.toggle('active');
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const menus = document.querySelectorAll('.tertiary-menu');
	const breakpoint = 10;
	const tripleBreakpoint = 24; // New breakpoint for dividing into three containers

	menus.forEach((menu) => {
		const menuItems = Array.from(menu.children);

		if (menuItems.length > tripleBreakpoint) {
			// Divide into three containers
			const containerOne = document.createElement('div');
			containerOne.classList.add('item-container', 'first-container');

			const containerTwo = document.createElement('div');
			containerTwo.classList.add('item-container', 'second-container');

			const containerThree = document.createElement('div');
			containerThree.classList.add('item-container', 'third-container');

			const thirdLength = Math.ceil(menuItems.length / 3);

			menuItems
				.slice(0, thirdLength)
				.forEach((item) => containerOne.appendChild(item));

			menuItems
				.slice(thirdLength, 2 * thirdLength)
				.forEach((item) => containerTwo.appendChild(item));

			menuItems
				.slice(2 * thirdLength)
				.forEach((item) => containerThree.appendChild(item));

			menu.innerHTML = '';
			menu.appendChild(containerOne);
			menu.appendChild(containerTwo);
			menu.appendChild(containerThree);

			menu.classList.add('triple-column');
		} else if (menuItems.length > breakpoint) {
			// Original logic for dividing into two containers
			const firstContainer = document.createElement('div');
			firstContainer.classList.add('item-container', 'first-container');

			const secondContainer = document.createElement('div');
			secondContainer.classList.add('item-container', 'second-container');

			menuItems
				.slice(0, menuItems.length / 2)
				.forEach((item) => firstContainer.appendChild(item));

			menuItems
				.slice(menuItems.length / 2)
				.forEach((item) => secondContainer.appendChild(item));

			menu.innerHTML = '';
			menu.appendChild(firstContainer);
			menu.appendChild(secondContainer);

			menu.classList.add('double-column');
		}
	});
});

document.addEventListener('DOMContentLoaded', function () {
	const menus = document.querySelectorAll('.tertiary-menu');

	menus.forEach((menu) => {
		const gapFiller = document.createElement('div');
		gapFiller.classList.add('gap-filler');

		menu.appendChild(gapFiller);
	});
});
